export enum ECourierView {
  RegisterView = "RegisterView",

  SignInView = "LoggedView",
}
